import { RevealText } from "@/components/shared/RevealText";
import { SectionLabel } from "@/components/shared/SectionLabel";
import { BenefitCard } from "@/components/shared/BenefitCard";
import { BENEFITS } from "@/data/siteData";

const BG_IMAGE =
  "https://images.unsplash.com/photo-1572847748080-bac263fae977?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

export const WhyMithraJobs = () => (
  <section className="relative py-24 px-6 bg-navy overflow-hidden">
    <img
      src={BG_IMAGE}
      alt=""
      className="absolute inset-0 w-full h-full object-cover opacity-[0.12]"
      aria-hidden="true"
    />
    <div className="max-w-7xl mx-auto relative">
      <div className="max-w-2xl mb-14">
        <SectionLabel light>Why Mithra Jobs</SectionLabel>
        <RevealText
          as="h2"
          text="Recruitment Built Around Your School"
          className="font-heading text-3xl sm:text-4xl font-semibold text-cream tracking-tight leading-tight"
        />
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {BENEFITS.map((b, i) => (
          <BenefitCard
            key={b.title}
            number={String(i + 1).padStart(2, "0")}
            title={b.title}
            description={b.description}
            delay={i * 0.08}
          />
        ))}
      </div>
    </div>
  </section>
);
